import { useState } from 'react'
import { stopScheduledInstall } from '../api/softseeWrites'
import { ApiError } from '../api/client'
import { toast } from '../ui/notify'

/**
 * Butonul .dp-stop din devicePackages.php: POST id la stopScheduledInstall,
 * "Stopped." / "Not stopped".
 */
export function StopScheduledInstall({ id, onStopped }: { id: number; onStopped?(): void }) {
  const [busy, setBusy] = useState(false)

  const onClick = async () => {
    if (busy) return
    setBusy(true)
    try {
      const body = await stopScheduledInstall(id)
      if (body.status !== 'OK') {
        toast(body.message || 'Not stopped', 'Error', 'error')
        return
      }
      toast(body.message || 'Stopped.', 'Stopped', 'success')
      onStopped?.()
    } catch (err) {
      toast(err instanceof ApiError ? err.message : 'Not stopped', 'Error', 'error')
    } finally {
      setBusy(false)
    }
  }

  return (
    <form className="stopScheduledInstall" action="/softsee/stopScheduledInstall" method="post" onSubmit={(e) => e.preventDefault()}>
      <input type="hidden" name="id" value={id} />
      <button type="button" className="btn btn-danger btn-sm dp-stop" data-id={id} disabled={busy} onClick={() => void onClick()}>
        Stop
      </button>
    </form>
  )
}
